module.exports = "/images/SouthKorea.png?f60ed27662c73afa6f4cc37fb7b4e57a";